module.exports = __webpack_public_path__ + "static/media/notification.723584c0.svg";